import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import CompanyInformation from './CompanyInformation';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Review from './Review';
import TextField from '@mui/material/TextField';

const useStyles = theme => ({
    root: {
        position: 'relative',
        // top: '-48px',
        paddingTop: '0',
        padding: '3%',
    },
    button: {
        marginTop: theme.spacing(2),
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    },
    textfield: {
        margin: theme.spacing(1),
        width: '250px',
        backgroundColor: '#ffffff'
    },
    reviewbutton: {
        align: 'right',
        marginTop: theme.spacing(2),
        marginLeft: '857px',
        width: '100px',
        backgroundColor: '#47a0c4',
        fontSize: '15px',
        fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0ba8cd',
            color: '#FFFFFF'
        },
    }
});

class ChooseSubscription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            comapnyInformation: false,
            review: false,
            chooseSubscription: true,
            subscription: '',
            integratedPayments: 'Yes',
            amount: '',
            perMonth: '',

            monthly: '',
            monthlyLabel: '',

            quarterly: '',
            quarterlyMonthRate: '',
            quarterlyLabel: '',

            yearly: '',
            yearlyMonthrate: '',
            yearlyLabel: '',

            discount: '',
            error: false,
            discountApplied: false,
            discountPercentage: '',
            discountedAmount: ''
        }
    }

    async componentDidMount() {
        console.log("total sites: ", this.props.sites)
        let totalSites = parseInt(this.state.sites)
        if (this.state.sites > 50) {
            const rate = 0.40
            //yearly
            let yearlyMonthrate = rate - (rate * 0.1)
            let yearly = yearlyMonthrate * 12
            console.log("yearly per month :  ", parseFloat(yearlyMonthrate).toFixed(2))
            console.log("yearly :  ", parseFloat(yearly).toFixed(2))

            //quarterly
            let quarterlyMonthRate = rate - (rate * 0.05)
            let quarterly = quarterlyMonthRate * 3
            console.log("quaterly per month:  ", parseFloat(quarterlyMonthRate).toFixed(2))
            console.log("quaterly total :  ", parseFloat(quarterly).toFixed(2))

            //monthly
            let monthly = rate * totalSites

            this.setState({
                // yearly
                yearlyMonthrate: parseFloat(yearlyMonthrate).toFixed(2),
                yearly: parseFloat(yearly).toFixed(2),
                yearlyLabel: 'Billed Yearly : $' + parseFloat(yearly).toFixed(2) + ' ($' + parseFloat(yearlyMonthrate).toFixed(2) + '/month)',
                amount: parseFloat(yearly).toFixed(2),
                perMonth: parseFloat(yearlyMonthrate).toFixed(2),

                //quarterly
                quarterlyMonthRate: parseFloat(quarterlyMonthRate).toFixed(2),
                quarterly: parseFloat(quarterly).toFixed(2),
                quarterlyLabel: 'Billed Quarterly: $' + parseFloat(quarterly).toFixed(2) + ' ($' + parseFloat(quarterlyMonthRate).toFixed(2) + '/month)',

                //monthly
                monthly: monthly,
                monthlyLabel: 'Billed Quarterly: $' + monthly
            })
        } else {
            const rate = 20

            //yearly
            let yearlyMonthrate = rate - (rate * 0.1)
            let yearly = yearlyMonthrate * 12
            console.log("yearly per month :  ", parseFloat(yearlyMonthrate).toFixed(2))
            console.log("yearly :  ", parseFloat(yearly).toFixed(2))

            //quarterly
            let quarterlyMonthRate = rate - (rate * 0.05)
            let quarterly = quarterlyMonthRate * 3
            console.log("quaterly per month:  ", parseFloat(quarterlyMonthRate).toFixed(2))
            console.log("quaterly total :  ", parseFloat(quarterly).toFixed(2))

            this.setState({
                // yearly
                yearlyMonthrate: parseFloat(yearlyMonthrate).toFixed(2),
                yearly: parseFloat(yearly).toFixed(2),
                yearlyLabel: 'Billed Yearly : $' + parseFloat(yearly).toFixed(2) + ' ($' + parseFloat(yearlyMonthrate).toFixed(2) + '/month)',
                amount: parseFloat(yearly).toFixed(2),
                perMonth: parseFloat(yearlyMonthrate).toFixed(2),

                //quarterly
                quarterlyMonthRate: parseFloat(quarterlyMonthRate).toFixed(2),
                quarterly: parseFloat(quarterly).toFixed(2),
                quarterlyLabel: 'Billed Quarterly: $' + parseFloat(quarterly).toFixed(2) + ' ($' + parseFloat(quarterlyMonthRate).toFixed(2) + '/month)',

                //monthly
                monthly: rate,
                monthlyLabel: 'Billed Quarterly: $' + rate
            })
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value,
        }, () => {
            this.addDiscount();
        }
        );
    };

    addDiscount = async () => {
        console.log(this.state.discount)
        let code = this.state.discount
        if (code === 'GUEST123' || code === 'CAMPGOOD' || code === 'RVOFFER' || code === 'GUEST987' || code === 'CAMPFIRE') {
            //10% discount
            let finalAmountAfterDiscount = this.state.amount - (this.state.amount * 0.1)
            console.log(parseFloat(finalAmountAfterDiscount).toFixed(2))
            this.setState({
                discountApplied: true,
                discountPercentage: '10%',
                discountedAmount: parseFloat(finalAmountAfterDiscount).toFixed(2),
                error: false
            })
        } else if (code === 'CAMPSAVE' || code === 'RVDEAL21' || code === 'GUEST555' || code === 'CAMPFUN7' || code === 'RVXPERT9') {
            //20% discount
            let finalAmountAfterDiscount = this.state.amount - (this.state.amount * 0.1)
            console.log(parseFloat(finalAmountAfterDiscount).toFixed(2))
            this.setState({
                discountApplied: true,
                discountPercentage: '20%',
                discountedAmount: parseFloat(finalAmountAfterDiscount).toFixed(2),
                error: false
            })
        } else if (code === 'RVSALE22' || code === 'GUESTBOOK' || code === 'CAMPUP10' || code === 'RVPERK88' || code === 'GUESTCARE') {
            //30% discount
            let finalAmountAfterDiscount = this.state.amount - (this.state.amount * 0.1)
            console.log(parseFloat(finalAmountAfterDiscount).toFixed(2))
            this.setState({
                discountApplied: true,
                discountPercentage: '30%',
                discountedAmount: parseFloat(finalAmountAfterDiscount).toFixed(2),
                error: false
            })
        } else {
            this.setState({
                error: true,
                discountApplied: false,
                discountPercentage: '',
                discountedAmount: '',
            })
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <>
                {this.state.comapnyInformation
                    ? <CompanyInformation firstname={this.props.firstName} lastName={this.props.lastName} emailId={this.props.emailId} password={this.props.password} phoneNumber={this.props.phoneNumber} username={this.props.username} />
                    : null}

                {this.state.review
                    ? <Review firstName={this.props.firstName} lastName={this.props.lastName} emailId={this.props.emailId} password={this.props.password}
                        phoneNumber={this.props.phoneNumber} username={this.props.username} businessName={this.props.businessName} businessPhoneNumber={this.props.businessPhoneNumber}
                        businessEmailAddress={this.props.businessEmailAddress} address={this.props.address} city={this.props.city} stateRegion={this.props.stateRegion} postalCode={this.props.postalCode}
                        country={this.props.country} website={this.props.website} locations={this.props.locations} sites={this.props.sites} businessType={this.props.businessType}
                        annualVolume={this.props.annualVolume} subscription={this.state.subscription} integratedPayments={this.state.integratedPayments} amount={this.state.amount} perMonth={this.state.perMonth} 
                        discountPercentage={this.state.discountPercentage} discountedAmount={this.state.discountedAmount}/>
                    : null}

                {this.state.chooseSubscription
                    ? <Grid container className={classes.root}>
                        <Box style={{ height: '50px', display: 'flex', flexDirection: 'row', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem' }} >
                                1. Create Account
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                2. Company Information
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#47a0c4', fontSize: '1.3rem', marginLeft: '10%' }} >
                                3. Choose a Subscription
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: '#c5cccf', fontSize: '1.3rem', marginLeft: '10%' }} >
                                4. Complete
                            </Typography>
                        </Box>

                        <Box style={{ height: '650px', display: 'flex', width: '100%', background: '#f3f3f3', padding: '2%', marginTop: '3%', justifyContent: 'center' }}>
                            <Grid>
                                <Grid container style={{ justifyContent: 'center' }}>
                                    <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.7rem', fontWeight: 'bold' }} >
                                        Choose your Subscription
                                    </Typography>
                                </Grid>
                                <Grid container>
                                    <FormControl>
                                        <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.5rem', marginTop: '30px', fontWeight: 'bold' }} >
                                            1. Choose your Subscription
                                        </Typography>
                                        <RadioGroup
                                            // defaultValue="Yearly"
                                            style={{ marginLeft: '150px' }}
                                        >
                                            <FormControlLabel value="Monthly" control={<Radio />} label={this.state.monthlyLabel} onChange={() => { this.setState({ subscription: 'Monthly', amount: this.state.monthly, perMonth: '' }) }} />
                                            <FormControlLabel value="Quaterly" control={<Radio />} label={this.state.quarterlyLabel} onChange={() => { this.setState({ subscription: 'Quaterly', amount: this.state.quarterly, perMonth: this.state.quarterlyMonthRate }) }} />
                                            <FormControlLabel value="Yearly" control={<Radio />} label={this.state.yearlyLabel} onChange={() => { this.setState({ subscription: 'Yearly', amount: this.state.yearly, perMonth: this.state.yearlyMonthrate }) }} />
                                            {this.state.subscription === 'Yearly'
                                                ? <Grid container>
                                                    <TextField id="discount" label="Discount Code" type="text"
                                                        className={classes.textfield} onChange={this.handleChange} style={{ marginTop: '20px', marginLeft: '40px' }} />
                                                    {/* <Button variant="contained" color="primary" className={classes.button} onClick={this.addDiscount} style={{ marginLeft: '30px', height: '50px', marginTop: '22px' }}> Apply </Button> */}
                                                </Grid>
                                                : null
                                            }
                                            {this.state.error
                                                ? <Typography variant="subtitle1" style={{ color: '#FF0000', fontSize: '1rem', marginLeft: '-30px' }} >
                                                    This discount code is not valid
                                                </Typography>
                                                : null
                                            }
                                            {this.state.discountApplied
                                                ? <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '-30px' }} >
                                                    Save {this.state.discountPercentage} more on ${this.state.amount}
                                                </Typography>
                                                : null
                                            }
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                {/* {this.state.subscription === 'Yearly'
                                    ? <Grid container style={{ justifyContent: 'center' }}>
                                        <TextField id="discount" required label="Discount Code" type="text"
                                            className={classes.textfield} onChange={this.handleFormChange} style={{ marginTop: '20px', marginLeft: '20px' }} />
                                    </Grid>
                                    : null
                                } */}
                                <Grid >
                                    <Grid container>
                                        <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1.5rem', marginLeft: '65px', marginTop: '50px', fontWeight: 'bold' }} >
                                            2. Integrated Payments for Reservations
                                        </Typography>
                                    </Grid>
                                    <Grid container>
                                        <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '107px' }} >
                                            We've integrated a Point of Sale and Card swipe terminal system using <b>CardConnect</b> (a Fiserv company) within OpenCampground.
                                        </Typography>
                                    </Grid>
                                    <Grid container>
                                        <Typography variant="subtitle1" style={{ color: '#000000', fontSize: '1rem', marginLeft: '107px' }} >
                                            Are you looking to accept credit cards for guest reservations?
                                        </Typography>
                                    </Grid>
                                    <Grid container>
                                        <FormControl>
                                            <RadioGroup
                                                // aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue="Yes"
                                                // name="radio-buttons-group"
                                                style={{ marginLeft: '150px' }}
                                            >
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" onChange={() => { this.setState({ integratedPayments: 'Yes' }) }} />
                                                <FormControlLabel value="No" control={<Radio />} label="No" onChange={() => { this.setState({ integratedPayments: 'No' }) }} />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.setState({ comapnyInformation: true, chooseSubscription: false }) }} >Back </Button>
                                    <Button variant="contained" color="primary" className={classes.reviewbutton} onClick={() => { this.setState({ review: true, chooseSubscription: false }) }} disabled={!this.state.subscription}>Review </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    : null
                }
            </>
        );
    };
};

export default withStyles(useStyles)(ChooseSubscription);